import carClass from "./carClass";
import client from "./client";
import color from "./color";
import contrAgent from "./contrAgent";
import executor from "./executor";
import history from "./history";
import object from "./object";
import objectGroup from "./objectGroup";
import order from "./order";
import service from "./service";
import dispatcher from "./dispatcher";
import vehicleType from "./vehicleType";
import orderArchiveModal from "./orderArchiveModal";
import orderModal from "./orderModal";
import transaction from "./transaction";
import counterparty from "./counterparty/index";
import reward from "./reward";
import dispatchersSelectTab from "./dispatchersSelectTab";
import counterpartyCheck from "./counterpartyCheck";
import counterpartyCheckCard from "./counterpartyCheckCard";
import counterpartyEmployee from "./counterpartyEmployee";
import counterpartyEmployeeCheck from "./counterpartyEmployeeCheck";
import counterpartyEmployeeCheckCard from "./counterpartyEmployeeCheckCard";
import counterpartyGroup from "./counterpartyGroup";
import agentGroup from "./agentGroup";
import clientGroup from "./clientGroup";
import customerTariff from "./customerTariff";
import agent from "./agent/index";
import orderAll from "./order/all";
import orderClosed from "./order/closed";
import orderExecutable from "./order/executable";
import orderLive from "./order/live";
import orderPreliminary from "./order/preliminary";
import orderArchive from "./order/archive";
import orderPoints from "./order/points";
import costomerCounterparty from "./costomerCounterparty";
import costomerCounterpartyGroupModal from "./costomerCounterpartyGroupModal";
import costomerCounterpartyGroupsModal from "./costomerCounterpartyGroupsModal";
import agentGroupsModal from "./agentGroupsModal";
import agentGroupModal from "./agentGroupModal";
import executorParameters from "./executorParameters";
import averageSpeed from "./averageSpeed";
import customerRateRule from "./customerRateRule";
import cashlessOrders from "./cashlessOrders";
import cashlessAccountsSummaryReport from "./cashlessAccountsSummaryReport";
import cashlessOrdersGeneral from "./cashlessOrdersGeneral";
import agentOrdersReport from "./agentOrdersReport";
import accountsReport from "./accountsReport";
import cashlessOrdersPeriodReport from "./cashlessOrdersPeriodReport";
import fuelDeductionOrdersReport from "./fuelDeductionOrdersReport";
import customerSelectTab from "./customerSelectTab";
/* order page */
import orderWidgetParkings from "./orderWidgetParkings";
import orderWidgetExecutors from "./orderWidgetExecutors";
/* reports menu salary page */
import reportsSalaryUsersActivity from "./reportsSalaryUsersActivity";
/* customers page */
import customersAgents from "./customersAgents";
import customersClients from "./customersClients";
import customersClientsModalFeedback from "./customersClientsModalFeedback";
import customersCounterparties from "./customersCounterparties";
/* preferences page */
import preferencesCarClass from "./preferencesCarClass";
import preferencesColors from "./preferencesColors";
import preferencesObjectFirstTable from "./preferencesObjectFirstTable";
import preferencesObjectSecondTable from "./preferencesObjectSecondTable";
import preferencesServices from "./preferencesServices";
/* accounts page */
import accountsExecutors from "./accountsExecutors";
import accountsTransportForModalInExecutors from "./accountsTransportForModalInExecutors";
import accountsTransport from "./accountsTransport";
import accountsUsers from "./accountsUsers";
import accountsRole from "./accountsRole";
import accountsCarParks from "./accountsCarParks";
import accountsWorkShifts from "./accountsWorkShifts";
import accountsExecutorTeams from "./accountsExecutorTeams";
/* accounting page */
import accountingExecutorsGeneral from "./accountingExecutorsGeneral";
import accountingExecutorsFirstTable from "./accountingExecutorsFirstTable";
import accountingExecutorsSecondTable from "./accountingExecutorsSecondTable";
import accountingBankAccountsFirstTable from "./accountingBankAccountsFirstTable";
import accountingBankAccountsSecondTableCards from "./accountingBankAccountsSecondTableCards";
import accountingBankAccountsSecondTableCalculations from "./accountingBankAccountsSecondTableCalculations";
import accountingAgentsFirstTable from "./accountingAgentsFirstTable";
import accountingAgentsSecondTable from "./accountingAgentsSecondTable";
import accountingReplenishPerformersBalance from "./accountingReplenishPerformersBalance";
/* acrhives page */
import archivesTransactions from "./archivesTransactions";
import archivesBankTransactions from "./archivesBankTransactions";
import archivesMessagesHistory from "./archivesMessagesHistory";
import archivesPushHistory from "./archivesPushHistory";
/* settings menu tariffs page */
import settingsTariffsMain from "./settingsTariffsMain";
/* settings menu finances page */
import settingsFinancesExecutorPenalties from "./settingsFinancesExecutorPenalties";
import settingsFinancesExecutorRatings from "./settingsFinancesExecutorRatings";
import settingsFinancesExecutorPenaltiesModalManualFines from "./settingsFinancesExecutorPenaltiesModalManualFines";
/* settings menu message page */
import settingsMessageProvider from "./settingsMessageProvider";
import settingsMessageTemplates from "./settingsMessageTemplates";
import settingsMessagePushNotices from "./settingsMessagePushNotices";
/* settings menu orderExchange page */
import settingsOrderExchangeMain from "./settingsOrderExchangeMain";
import carSelectTab from "./carSelectTab";
/* settings menu carParks page */
import settingsCarParksGeneral from "./settingsCarParksGeneral";
// mobile app
import customerApp from "./customerApp";

const tables = {
	averageSpeed,
	agentGroupsModal,
	agentGroupModal,
	costomerCounterpartyGroupModal,
	costomerCounterpartyGroupsModal,
	counterpartyEmployeeCheck,
	counterpartyEmployeeCheckCard,
	carClass,
	vehicleType,
	color,
	cashlessOrders,
	cashlessAccountsSummaryReport,
	cashlessOrdersGeneral,
	fuelDeductionOrdersReport,
	cashlessOrdersPeriodReport,
	accountsReport,
	agentOrdersReport,
	object,
	objectGroup,
	service,
	executor,
	dispatcher,
	executorParameters,
	order,
	dispatchersSelectTab,
	client,
	contrAgent,
	history,
	orderAll,
	orderClosed,
	orderExecutable,
	orderLive,
	orderPreliminary,
	orderArchive,
	orderPoints,
	orderArchiveModal,
	orderModal,
	customerTariff,
	customerRateRule,
	transaction,
	agent,
	counterparty,
	counterpartyCheck,
	counterpartyCheckCard,
	counterpartyEmployee,
	counterpartyGroup,
	agentGroup,
	clientGroup,
	costomerCounterparty,
	reward,
	customerSelectTab,
	/* order page */
	orderWidgetParkings,
	orderWidgetExecutors,
	/* reports menu salary page */
	reportsSalaryUsersActivity,
	/* customers page */
	customersAgents,
	customersClients,
	customersClientsModalFeedback,
	customersCounterparties,
	/* preferences page */
	preferencesCarClass,
	preferencesColors,
	preferencesObjectFirstTable,
	preferencesObjectSecondTable,
	preferencesServices,
	/* accounts page */
	accountsExecutors,
	accountsTransportForModalInExecutors,
	accountsTransport,
	accountsUsers,
	accountsRole,
	accountsCarParks,
	accountsWorkShifts,
	accountsExecutorTeams,
	/* accounting page */
	accountingExecutorsGeneral,
	accountingExecutorsFirstTable,
	accountingExecutorsSecondTable,
	accountingBankAccountsFirstTable,
	accountingBankAccountsSecondTableCards,
	accountingBankAccountsSecondTableCalculations,
	accountingAgentsFirstTable,
	accountingAgentsSecondTable,
	accountingReplenishPerformersBalance,
	/* acrhives page */
	archivesTransactions,
	archivesBankTransactions,
	archivesMessagesHistory,
	archivesPushHistory,
	/* settings menu tariffs page */
	settingsTariffsMain,
	/* settings menu finances page */
	settingsFinancesExecutorPenalties,
	settingsFinancesExecutorRatings,
	settingsFinancesExecutorPenaltiesModalManualFines,
	/* settings menu message page */
	settingsMessageProvider,
	settingsMessageTemplates,
	settingsMessagePushNotices,
	/* settings menu orderExchange page */
	settingsOrderExchangeMain,
	carSelectTab,
	/* settings menu carParks page */
	settingsCarParksGeneral,
	customerApp,
} as const;

export default tables;
